import {
  AdAnalyticsFilter,
  // AdAnalyticsVideo,
  AdAnalyticsVideoFilter,
  AdAnalyticsVideoSort,
} from '@kaizenplatform/hugot-entity';
import { createElement, FC, useContext } from 'react';
import { RouteComponentProps } from 'react-router';

import { context as DependencyContext } from '../context/dependency';
import { context as StateContext } from '../context/state';
import Page from '../page/ShowAdAnalyticsListPage';

type Props = RouteComponentProps;

const AdAnalyticsListPage: FC<Props> = () => {
  const state = useContext(StateContext);
  const dependency = useContext(DependencyContext);
  return (
    <Page
      loading={state.adAnalyticsVideos.fetching >= 1 || state.adAnalyticsPlacementTypes.fetching >= 1}
      appendLoading={state.adAnalyticsVideos.appendFetching >= 1}
      creatives={state.creativePerformanceCreatives.creatives}
      campaigns={state.creativePerformanceCreatives.campaigns}
      ads={state.creativePerformanceCreatives.ads}
      placementTypes={state.adAnalyticsPlacementTypes.placementTypes}
      selectedPlacementTypes={state.adAnalyticsPlacementTypes.selectedPlacementTypes}
      selectedVideos={state.adAnalyticsVideos.selectedVideos}
      filters={state.adAnalyticsVideos.filters}
      sort={state.adAnalyticsVideos.sort}
      hasMoreVideo={state.adAnalyticsVideos.pageInfo ? state.adAnalyticsVideos.pageInfo.hasNextPage : false}
      onClickLoadMoreVideoButton={() => {
        if (state.adAnalyticsVideos.pageInfo && state.adAnalyticsVideos.pageInfo.endCursor) {
          dependency.listAdAnalyticsVideoUsecase.loadMoreVideos(state.adAnalyticsVideos.pageInfo.endCursor);
        }
      }}
      onUpdatePlacementTypes={({ platformKey, mediaKey, placementKey, period }: AdAnalyticsFilter) => {
        dependency.listAdAnalyticsVideoUsecase.updatePlacementTypes({ platformKey, mediaKey, placementKey, period });
      }}
      onSubmitPlacementTypes={() => {
        dependency.listAdAnalyticsVideoUsecase.submitPlacementTypes();
      }}
      // onGotoAnalyticsPage={(idList: string[]) => {
      //   dependency.listAdAnalyticsVideoUsecase.goAnalyticsPage(idList);
      // }}
      // onGotoReportListPage={() => {
      //   dependency.listAdAnalyticsVideoUsecase.goReportListPage();
      // }}
      onSubmitFilters={(filters: AdAnalyticsVideoFilter[]) => {
        dependency.listAdAnalyticsVideoUsecase.submitFilters(filters);
      }}
      onUpdateSort={(sort: AdAnalyticsVideoSort) => {
        dependency.listAdAnalyticsVideoUsecase.updateSort(sort);
      }}
      onMount={() => {
        dependency.authenticationUsecase.needSignedIn();
        dependency.listAdAnalyticsVideoUsecase.prepare();
      }}
      onUnmount={() => {
        dependency.listAdAnalyticsVideoUsecase.dispose();
      }}
    />
  );
};

export default AdAnalyticsListPage;
